import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardViewJobPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/ViewJobPageContainer" */
      './OrgDashboardViewJobPageContainer.dynamic'
    ),
});
